import React, { Component } from "react";
import { tableIcons } from "utils/MaterialTableHelper";
import colors from "styles/colors.module.scss";
import "./UserAdminContent.scss";
import { uepClient } from "uepClient";
import WithAlert from "hoc/WithAlert";
import { getUsername } from "utils/Common";
import TableToolbar from "./TableToolbar";
import AdminTableWrapper from "./AdminTableWrapper";
import { UserStatus } from "constants/UserConstants";
import { Modal } from "react-bootstrap";
import AddUserForm from "components/AddUserForm/AddUserForm";
import UserSummaryService from "services/UserSummaryService";
import Channels from "components/Channels/Channels";

class UserAdminContent extends Component {
  static propTypes = {};
  constructor() {
    super();
    this.state = {
      isLoading: true,
      usersData: {
        totalPages: 0,
        currentPageSize: 0,
        users: [],
      },
      selectedRows: [],
      searchText: "",
      showAddUserForm: false,
      isEditMode: false,
    };
    this.currentUser = getUsername();
  }
  componentDidMount() {
    this.fetchAllUsers();
  }
  render() {
    const { isLoading, showAddUserForm } = this.state;
    return (
      <div className="admin-content">
        <div className="admin-list-table-container">
          <div className="table-wrapper">
            {this.renderTableToolbar()}
            <AdminTableWrapper
              icons={tableIcons}
              columns={this.getTableColumns()}
              data={this.getUserRecords()}
              isLoading={isLoading}
              onSelectionChange={this.onRowSelection}
              emptyMessage="No users found."
              isRowSelected={this.isRowSelected}
            />
          </div>
        </div>
        <Modal
          className="add-entity-modal"
          centered
          onHide={this.onAddUserFormClose}
          show={showAddUserForm}
        >
          <AddUserForm
            onFormClose={this.onAddUserFormClose}
            addNewUserToTable={this.addNewUserToTable}
            isEditMode={this.state.isEditMode}
            updateUserInTable={this.updateUserInTable}
            userToUpdate={this.state.selectedRows[0]}
          />
        </Modal>
      </div>
    );
  }
  isRowSelected = (row) => {
    const { selectedRows } = this.state;
    const selectedRowIndex = selectedRows.findIndex(
      (r) => r.username === row.username
    );
    return selectedRowIndex > -1;
  };
  renderTableToolbar = () => {
    return (
      <TableToolbar
        searchValue={this.state.searchText}
        onSearchTextChange={this.onSearchTextChange}
        onAddButtonClick={this.onAddUserClick}
        isEditEnabled={this.state.selectedRows.length === 1}
        isDeleteEnabled={this.state.selectedRows.length > 0}
        onDeleteClick={this.onDeleteClick}
        onEditClick={this.onEditClick}
        title="Manage User"
      />
    );
  };

  onDeleteClick = () => {
    const { selectedRows } = this.state;
    const selectedUsernames = selectedRows.map((r) => r.username);
    this.deleteUsernames(selectedUsernames);
  };

  deleteUsernames = (selectedUsernames) => {
    this.setState({
      isLoading: true,
    });
    uepClient()
      .post("/user/deactivate", selectedUsernames)
      .then((res) => {
        if (res.status === 200) {
          this.removeDeletedUsersFromTable(selectedUsernames);
          console.info(
            `Admin ${this.currentUser} deleted usernames: ${selectedUsernames}`
          );
          this.props.showAlert({
            variant: "success",
            content: (
              <span>
                <b>Succesfully</b> deleted the selected users.
              </span>
            ),
          });
        }
      })
      .catch((err) => {
        const errorMessageToDisplay =
          err.response.status === 409
            ? err.response.data
            : "occurred while deleting the selected users.";

        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> {errorMessageToDisplay}
            </span>
          ),
        });
        console.error(
          `Error occurred while Admin-${
            this.currentUser
          } trying to delete usernames: ${selectedUsernames.join(",")}, ${err}`
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  notifyUserAdminSummary = () => {
    UserSummaryService.fetchUserSummaryData();
  };

  addNewUserToTable = (newUser) => {
    const { usersData } = this.state;

    const newUserToAppend = {
      channels: newUser.channels,
      creationDateTime: newUser.creationDateTime,
      email: newUser.email,
      employeeId: newUser.employeeId,
      firstName: newUser.firstName,
      group: newUser.group,
      lastName: newUser.lastName,
      mobileNumber: newUser.mobileNumber,
      role: newUser.role,
      skills: newUser.skills,
      status: newUser.status,
      username: newUser.username,
    };

    const existingUsers = [].concat(usersData.users);

    const updatedUsers = existingUsers.concat(newUserToAppend);
    this.setState({
      usersData: {
        ...usersData,
        users: updatedUsers,
      },
      selectedRows: [],
    });

    this.notifyUserAdminSummary();
  };

  updateUserInTable = (updatedUser) => {
    const { usersData } = this.state;
    const existingUsers = [].concat(usersData.users);
    const indexOfExistingUserToUpdate = existingUsers.findIndex(
      (user) => user.username === updatedUser.username
    );
    if (indexOfExistingUserToUpdate !== -1) {
      existingUsers.splice(indexOfExistingUserToUpdate, 1, updatedUser);
    }
    this.setState({
      usersData: {
        ...usersData,
        users: existingUsers,
      },
      selectedRows: [],
    });

    this.notifyUserAdminSummary();
  };

  removeDeletedUsersFromTable = (deletedUsernames) => {
    const { usersData } = this.state;
    const updatedUsersData = usersData.users.filter(
      (u) => !deletedUsernames.includes(u.username)
    );
    this.setState({
      usersData: {
        ...usersData,
        users: updatedUsersData,
      },
      selectedRows: [],
    });

    this.notifyUserAdminSummary();
  };

  onEditClick = () => {
    this.setState({
      showAddUserForm: true,
      isEditMode: true,
    });
  };

  onAddUserClick = () => {
    this.setState({
      isEditMode: false,
      showAddUserForm: true,
    });
  };

  onAddUserFormClose = () => {
    this.setState({
      showAddUserForm: false,
    });
  };

  onSearchTextChange = (searchText) => {
    this.setState({
      searchText,
    });
  };

  fetchAllUsers = () => {
    uepClient()
      .get("/user")
      .then((res) => {
        this.setState({
          usersData: res.data,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.error(`Failed to fetch list of users for admin : ${err}`);
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to fetch list of users for admin.
            </span>
          ),
        });
      });
  };
  getUserRecords = () => {
    const { usersData, searchText } = this.state;
    const recordsExcludingCurrentUser = usersData.users.filter(
      (u) => u.username !== this.currentUser && u.status === UserStatus.ACTIVE
    );
    return searchText.trim().length
      ? recordsExcludingCurrentUser.filter((r) => this.validateSearch(r))
      : recordsExcludingCurrentUser;
  };
  validateSearch = (row) => {
    const { searchText } = this.state;
    const searchLc = searchText.toLowerCase();
    const userNameValidator = row.username.toLowerCase().includes(searchLc);
    const nameValidator = row.firstName
      ? row.firstName.toLowerCase().includes(searchLc)
      : false;
    const groupValidator = row.group.toLowerCase().includes(searchLc);
    const roleValidator = row.role.toLowerCase().includes(searchLc);
    const channelsValidator = row.channels.some((c) =>
      c.toLowerCase().includes(searchLc)
    );
    const skillsValidator = row.skills.some((skill) =>
      skill.name.toLowerCase().includes(searchLc)
    );
    return (
      userNameValidator ||
      nameValidator ||
      groupValidator ||
      roleValidator ||
      channelsValidator ||
      skillsValidator
    );
  };
  getTableColumns = () => {
    const tableColumns = [
      {
        title: "Name / Agent Id",
        field: "name",
        render: (rowData) => {
          let fullName;
          if (rowData.firstName && rowData.lastName) {
            fullName = `${rowData.firstName} ${rowData.lastName}`.trim();
          }
          return fullName ? fullName : rowData.username;
        },
        filtering: false,
        sorting: false,
      },
      {
        title: "Group",
        field: "group",
        filtering: true,
        render: (rowData) => {
          if (rowData.group !== "NA") {
            return rowData.group;
          } else return "";
        },
      },
      {
        title: "Role",
        field: "role",
        filtering: true,
      },
      {
        title: "Skills",
        field: "skills",
        filtering: true,
        render: (rowData) => {
          if (rowData.skills.length) {
            const skillNames = rowData.skills.map((skill) => skill.name);
            return skillNames.join(", ");
          } else return "";
        },
        sorting: false,
      },
      {
        title: "Channels",
        field: "channels",
        render: (rowData) => {
          if (rowData.channels.length) {
            return <Channels channels={rowData.channels} />;
          } else return "";
        },
        sorting: false,
      },
    ];

    const tableColumnsWithStyle = tableColumns.map((tc) => ({
      ...tc,
      cellStyle: {
        border: 0,
        color: colors.darkGrey,
        fontWeight: "normal",
      },
      headerStyle: {
        border: 0,
        color: colors.darkGrey,
        fontWeight: "300",
        fontSize: "1em",
      },
    }));
    return tableColumnsWithStyle;
  };

  onRowSelection = (rows) => {
    this.setState({
      selectedRows: rows,
    });
  };
}

export default WithAlert(UserAdminContent);
